import React, { useEffect, useState } from "react";
import TXT from "presentational/common/multinational/TXT";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import CommonModalView from "presentational/common/modals/CommonModalView";
import { useCookies } from "react-cookie";
import { withStore } from "store/storeHandler";
import { withStyles } from "@material-ui/core/styles";
import CommonSnackbarView from "presentational/common/CommonSnackbarView";
import PropTypes from "prop-types";
import config from "lib/fr-config";

const zIndexOfSnackbar = config.css.zIndex.snackbar.cookieConsent;

const CustomCheckbox = withStyles({
  root: {}
})(Checkbox);
const MajorTypography = withStyles({
  root: { fontSize: 18, paddingTop: 10, paddingBottom: 10 }
})(Typography);
const MinorTypography = withStyles({
  root: { fontSize: 14, paddingBottom: 10 }
})(Typography);
const CustomDivider = withStyles({
  root: { marginTop: 10, marginBottom: 10 }
})(Divider);

CookieConsentSnackbar.propTypes = {
  readyToShow: PropTypes.bool.isRequired,
  complitionCallbackFn: PropTypes.func
};

CookieConsentSnackbar.defaultProps = {
  complitionCallbackFn: () => {}
};

function CookieConsentSnackbar(props) {
  const { readyToShow, complitionCallbackFn } = props;
  const { GoogleAnalyticsActions } = props;
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isSnackbarAlreadyInit, setIsSnackbarAlreadyInit] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [performanceChkbox, setPerformanceChkbox] = useState(false);

  const [cookies, setCookies] = useCookies(["MaConsent"]);

  useEffect(() => {
    if (isSnackbarAlreadyInit) return undefined;

    setIsSnackbarAlreadyInit(true);
    initSnackbar();
  }, []);

  const initSnackbar = () => {
    const rawCookieValue = cookies["MaConsent"];
    const cookieValue =
      typeof rawCookieValue === "object" ? rawCookieValue : null;

    if (cookieValue && cookieValue.timestamp) {
      complitionCallbackFn();
    } else {
      /** [할일 : 쿠키 모달 켜기] 로그인시 쿠키여부 묻는 코드. */
      handleConsentBtnClick("all")(); // 임시코드
      // setSnackbarOpen(true); // 원래 코드
      /** 로그인시 쿠키여부 묻는 코드 끝F. */
    }
  };

  const parseCookieValue = type => {
    const nowDate = new Date();

    let analyticsCookie;
    switch (type) {
      case "all":
        analyticsCookie = true;
        break;
      case "necessary":
        analyticsCookie = false;
        break;
      case "selected":
        analyticsCookie = performanceChkbox;
        break;
      default:
        console.error("wrong type", type);
        break;
    }

    const valueObj = { analyticsCookie, timestamp: nowDate.getTime() };
    return JSON.stringify(valueObj);
  };

  const setMaCookie = cookieValue => {
    setCookies("MaConsent", cookieValue, {
      path: "/",
      maxAge: 31536000
    });
  };

  const startGA = cookieValue => {
    const { analyticsCookie } = JSON.parse(cookieValue);
    if (analyticsCookie) {
      GoogleAnalyticsActions.startAnalyzingNewUser();
    }
  };

  const getSnackbarButtonInfoArray = () => {
    return [
      {
        color: "primary",
        func: handleConsentBtnClick("all"),
        btnText: <TXT name="btnSnackbar_acceptAllCookies" />
      },
      // "모든 쿠키 거부" 버튼 임시 비활성화함.
      // {
      //   color: "primary",
      //   func: handleConsentBtnClick("necessary"),
      //   btnText: <TXT name="btnSnackbar_rejectAllCookies" />
      // },
      {
        color: "secondary",
        func: handleCustomizeBtnClick,
        btnText: <TXT name="btnSnackbar_customizeCookies" />
      }
    ];
  };

  const getCustomizeModalContent = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <MajorTypography>
            <TXT name="msg_necessaryCookieMajor" />
          </MajorTypography>
          <CustomCheckbox checked={true} disabled disableRipple />
        </div>
        <MinorTypography>
          <TXT name="msg_necessaryCookieMinor" />
        </MinorTypography>
        <CustomDivider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <MajorTypography>
            <TXT name="msg_analyticsCookieMajor" />
          </MajorTypography>
          <CustomCheckbox
            checked={performanceChkbox}
            onChange={handleCheckboxChange}
            color="primary"
            disableRipple
            value={"performanceChkbox"}
          />
        </div>
        <MinorTypography>
          <TXT name="msg_analyticsCookieMinor" />
        </MinorTypography>
      </div>
    );
  };

  const handleCustomizeBtnClick = () => {
    setModalOpen(true);
    setSnackbarOpen(false);
  };

  const handleCheckboxChange = e => {
    const { value, checked } = e.target;
    if (value === "performanceChkbox") {
      setPerformanceChkbox(checked);
    }
  };

  const handleConsentBtnClick = type => () => {
    const cookieValue = parseCookieValue(type);

    setMaCookie(cookieValue);

    setSnackbarOpen(false);
    setModalOpen(false);

    startGA(cookieValue);

    complitionCallbackFn();
  };

  return (
    <div>
      <CommonSnackbarView
        open={snackbarOpen && readyToShow}
        contentComponent={
          <span style={{ fontSize: 12 }}>
            <TXT name="msg_cookieConsentRequest" />
          </span>
        }
        buttonInfoArray={getSnackbarButtonInfoArray()}
        zIndexOfSnackbar={zIndexOfSnackbar}
      />
      <CommonModalView
        open={modalOpen}
        onClose={() => {}}
        titleText={<TXT name="titleModal_cookieCustom" />}
        contentComponent={getCustomizeModalContent()}
        firstButtonText={<TXT name="btnModal_saveMyCookieAndExit" />}
        firstButtonFunc={handleConsentBtnClick("selected")}
        secondButtonText={<TXT name="btnModal_acceptAllCookies" />}
        secondButtonFunc={handleConsentBtnClick("all")}
      />
    </div>
  );
}

export default withStore({
  dispatchMap: ["googleAnalytics"]
})(CookieConsentSnackbar);
